import React from "react";

import { CoreProps } from "./util";
import AutoSortGrid, { AutoSortProps } from "./AutoSortGrid";
import GridImpl, { ImplProps, ImplSortProps } from "./GridImpl";
import WithGridContext from "./GridContext";
import Loading from "ui/Loading";

export { type GridColumn, type CellData } from "./util";

export {
  NumberCell,
  MsCell,
  BytesCell,
  NoDataGridContainer,
  PageHeightWrapper,
} from "./GridImpl";

export { default as GridSettingsButton } from "./GridSettingsButton";

export { default as GridPageControls } from "./GridPageControls";

type SortProps<T> =
  | (AutoSortProps<T> & { handleSort?: never })
  | (ImplSortProps<T> & { defaultSortBy?: never });

type Props<T> = CoreProps<T> &
  SortProps<T> & {
    header?: React.ReactNode;
    loading?: boolean;
    error?: boolean;
  };

function Grid<T>(props: Props<T>) {
  const { header, loading, error, ...rest } = props;

  // If we're dealing with an external sort, just pass through the props.
  // Otherwise, use a wrapper that will handle sorting
  const impl =
    "handleSort" in rest ? (
      <GridImpl {...(rest as ImplProps<T>)} />
    ) : (
      <AutoSortGrid {...rest} />
    );

  // The header stays mounted while the body below swaps to a loading spinner
  // during refetches to avoid e.g. losing focus due to remounting.
  return (
    <WithGridContext columns={props.columns}>
      {header}
      {loading || error ? <Loading error={!!error} /> : impl}
    </WithGridContext>
  );
}

export default Grid;
